<template>
  <v-autocomplete
    id="temas-select"
    v-model="filter.ator"
    item-text="nome"
    item-value="atorId"
    :items="values"
    :label="label"
    :rules="rules"
    :placeholder="label"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    :clearable="true"
    :return-object="true"
  >
    <template slot="no-data"> Nenhum Ator retornado </template>
  </v-autocomplete>
</template>

<script>
import { atoresApi } from "@/apis";
import { mapActions } from "vuex";

export default {
  name: "AppEixoCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    label: {
      type: String,
      default: () => {
        "Atores";
      },
    },
    defaultValue: {
      type: String | Number,
    },
    filter: {
      type: Object,
      default: () => {
        ({ ator: {} });
      },
    },
    municipioId: {
      type: String,
      default: () => {
        "0";
      },
    },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.load();
  },
  watch: {
    defaultValue(value) {
      if (value && this.values.length > 0) {
        this.filter.ator = this.values.filter(
          (item) => item.idAtor === value
        )[0];
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      this.setLoading(true);
      atoresApi
        .getByMunicipio(this.municipioId)
        .then((resp) => {
          this.setLoading(false);
          this.values = resp.data;

          if (this.defaultValue) {
            this.filter.ator = this.values.filter(
              (item) => item.idAtor === this.defaultValue
            )[0];
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          console.log("Erro ao obter atores: ", resp);
          this.$notification.error("Erro ao obter Atores");
        });
    },
  },
  data() {
    return {
      values: [],
    };
  },
};
</script>
